import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ViewBasePage } from '@shared/pages';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

@Component({
    'selector': 'app-tracker',
    'templateUrl': './tracker.page.html',
    'styleUrls': ['./tracker.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class TrackerPage extends ViewBasePage implements OnInit, OnDestroy {
    public debugMode = false;

    constructor( injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter() {
        super.setCurrentView(this.Constants.VIEW_TRACKER);
        super.ngOnInit();
        this.debugMode = this.sessionService.isDebugMode();
        this.initMoreMenu();
    }

    public ionViewWillLeave() {
        super.ngOnDestroy();
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Show Tour', 'show-tracker-tour');
    }

    public onTrackerLiveClick(): void {
        const vm = {
            'sbb': true
        }; 
        this.setViewModel(vm);
        this.router.navigateByUrl('/tracker/trackerLive');
    }

    public onTrackerHistoricalClick(): void {
        this.router.navigateByUrl('/tracker/tracker1HistoricalFilter')
    }
}
